import React, { useState } from 'react';
import '../App.css';
import Select from 'react-select';
import axios from 'axios';
import cookie from 'react-cookies';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import {
	useStripe,
	useElements,
	CardNumberElement,
	CardCvcElement,
	CardExpiryElement
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe("pk_test_370qjoE9grb7T4nk8CH6kZyx00qUhUOKLR");

const Buysubscription = props => {
	const stripe = useStripe();
	const elements = useElements();
	
	const [plan, setPlan] = useState('');
	const [payment, setPayment] = useState('');
	const [message, setMessage] = useState('');
	const [cardholderName, setCardholder] = useState('');
	const [email, setEmail] = useState('');
	const [flag_card, setFlagCard] = useState(false);

	const[planList, setPlanList] = useState([]);

	const paymentList = [
			  { value: 'xchange', label: props.dataLanguage['xchange'] },
			  { value: 'card', label: props.dataLanguage['card'] }
			];
	

	const planChangeHandler = value => {
		setPlan(value);
	}

	const paymentChangeHandler = value => {
		setPayment(value.value);

		if (value.value === "card") {
			setFlagCard(true);
			setPlanList([
			  { value: 'monthly', label: props.dataLanguage['per_month'] },
			  { value: 'annual', label: props.dataLanguage['per_year'] }
			]);

			setPlan({ value: 'monthly', label: props.dataLanguage['per_month'] });
		} else {
			setFlagCard(false);
			setPlanList([
			  { value: 'monthly', label: props.dataLanguage['per_month_xchange'] },
			  { value: 'annual', label: props.dataLanguage['per_year_xchange'] }
			]);

			setPlan({ value: 'monthly', label: props.dataLanguage['per_month_xchange'] });
		}
	}

	const cardHolderChangeHandler = e => {
		setCardholder(e.target.value);
	}
	
	const emailChangeHandler = e => {
		setEmail(e.target.value);
	}

	const submitBuySubscription = async event => {
		event.preventDefault();

		if (payment == 'xchange') {
			var amount = 300;
			if (plan.value == 'annual') {
				amount = 3000;
			}

			if (props.xchangeAmount < amount) {
				return;
			}

			const payment_data = {
				type: 1,
				userId: cookie.load('cookieId'),
				payment_option: 'xchange',
				intent_id: '',
				intent_status: '',
				amount: amount,
				cardholder: '',
				email: ''
			}

			axios.post(window.$backend_url + '/add_payment', payment_data)
				.then(response => {
					props.closeBuySubscription();
				})
				.catch(error => {
					console.log(error);
				})
		} else if (payment == 'card') {
			if (!stripe || !elements || !cardholderName || !email) {
				return;
			}

			if (plan) {
				const payload = await stripe.createPaymentMethod({
					type: "card",
					card: elements.getElement(CardNumberElement),
					billing_details: {
						name: cardholderName,
						email: email
					}
				});

				var amount = 300;
				if (plan.value == 'annual') {
					amount = 3000;
				}
				
				if (payload) {
					const data = {
						amount: amount,
						payment_method: payload.paymentMethod.id,
						description: "Buy subscription on DigitXchange"
					}

					axios.defaults.withCredentials = true;
					axios.post(window.$backend_url + '/get_paymentIntent', data)
						.then(response => {
							stripe.confirmCardPayment(response.data.client_secret, {
								payment_method: payload.paymentMethod.id,
							})
							.then(function(result) {
								if (result.paymentIntent.status == "succeeded") {
									const payment_data = {
										type: 1,
										userId: cookie.load('cookieId'),
										payment_option: 'card',
										intent_id: result.paymentIntent.id,
										intent_status: result.paymentIntent.status,
										amount: result.paymentIntent.amount,
										cardholder: cardholderName,
										email: email
									}

									axios.post(window.$backend_url + '/add_payment', payment_data)
										.then(response => {
											props.closeBuySubscription();
										})
										.catch(error => {
											console.log(error);
										})
								}
							})
						})
						.catch(error => {
							console.log(error);
						})
				}
			}
		}
	}
	
	
	const options = {
		style: {
			base: {
				color: "#ffd33f",
				letterSpacing: "0.025em",
				fontSize: "1rem",
				fontFamily: "Source Code Pro, monospace",
				"::placeholder": {
					color: "#808080"
				}
			},
			invalid: {
				color: "#9e2146"
			}
		}
	};

	const customStyles = {
		control: styles => ({ 
			...styles,
			backgroundColor: '#313131',
			color: '#ffd33f',
			border: 'solid 1px #64541c',
			boxShadow: 'none',
			outline: 'none',
			"&:hover": {
				border: 'solid 1px #ffd33f',
				color: 'white',
				outline: 'none',
				boxShadow: 'none'
			},
			"&:focus": {
				border: 'solid 1px #ffd33f',
				color: 'white',
				outline: 'none',
				boxShadow: 'none'
			}
		}),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				backgroundColor: isFocused ? '#ddd' : 'white',
				color: isFocused ? 'black' : 'gray',
				padding: '10px',
				size: 5,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			};
		},
		container: (base, state) => ({
			...base,
			border: state.isFocused ? null : null,
			"&:hover": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			},
			"&:focus": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			}
		}),
		singleValue: (provided, state) => ({
			...provided,
			color: "#ffd33f",
			"&:hover": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			},
			"&:focus": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			}
		})
	}

	return(
		<div className="modal-buy-subscription custom-modal">
			<div className="modal-logo">
				<img alt="logo" src="/assets/images/logo.png" />
			</div>
			<h2 className="text-center">{props.dataLanguage['buy_subscription']}</h2>
			<form className="payment-form">
				{ message ?
					<p className="message-text">{ message }</p>
				: null }
				<div className="form-group">
					<div className="flex">
						<label>{props.dataLanguage['payment_options']}</label>
						<div className="payment_cards text-right">
							<img alt="coin" src="/assets/images/coin.png" />
							<span className="link-yellow">{props.dataLanguage['or']}</span>
							<img alt="coin" src="/assets/images/cards.png" />
						</div>
					</div>
					<Select styles={customStyles} options={paymentList} onChange={paymentChangeHandler} placeholder={props.dataLanguage['select']} />
				</div>
				<div className="form-group">
					<label>{props.dataLanguage['subscription_plan']}</label>
					<Select styles={customStyles} options={planList} onChange={planChangeHandler} placeholder={props.dataLanguage['select']} value={plan} />
				</div>
				{flag_card ?
					<div className="stripe_form">
						<label>
							{props.dataLanguage['card_number']}
							<CardNumberElement
								options={options}
							/>
						</label>
						<div className="row">
							<div className="col-6">
								<label>
									{props.dataLanguage['cvc']}
									<CardCvcElement
										options={options}
									/>
								</label>
							</div>
							<div className="col-6">
								<label>
									{props.dataLanguage['expiration_date']}
									<CardExpiryElement
										options={options}
									/>
								</label>
							</div>
						</div>
						<div className="form-group">
							<label>{props.dataLanguage['cardholder_name']}</label>
							<input value={cardholderName} onChange={cardHolderChangeHandler} type="text" className="form-control card" name="card" />
						</div>
						<div className="form-group">
							<label>{props.dataLanguage['email']}</label>
							<div className="user-container">
								<input value={email} onChange={emailChangeHandler} type="email" className="form-control useremail" name="useremail" />
							</div>
						</div>
					</div>
				: null
				}
				<button onClick={submitBuySubscription} type="submit" className="btn-submit">{props.dataLanguage['submit_order']}</button>					 
			</form>
		</div>
	)
}

export default Buysubscription;


// WEBPACK FOOTER //
// ./src/components/Buysubscription.js